export default __webpack_public_path__ + "static/media/testimony_student_three.19c51dd8.png";